module.exports = __webpack_public_path__ + "img/lost.05e60c39.png";